import { z } from "zod";

//로그인 스키마
export const LoginSchema = z.object({
    email: z.string().min(1, { message: "이메일을 입력해주세요" }),
    password: z.string(),
});

//회원가입 스키마
export const SignupSchema = z
    .object({
        user_id: z
            .string()
            .min(1, { message: "이메일을 입력해주세요" })
            .email({ message: "이메일 양식이 올바르지 않습니다" }),
        password: z
            .string()
            .min(1, { message: "비밀번호를 입력해주세요" })
            .min(8, { message: "비밀번호는 8자 이상이어야 합니다" })
            .regex(
                /^[A-Za-z\d@$!%*#?&]*$/,
                { message: "특수문자는 @$!%*#?&만 가능합니다" }
            )
            .regex(
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                { message: "비밀번호는 영문, 숫자, 특수문자를 포함해야 합니다" }
            ),
        confirmPassword: z
            .string()
            .min(1, { message: "비밀번호 확인을 입력해주세요" }),
        hp: z
            .string()
            .min(1, { message: "휴대폰 번호를 입력해주세요" })
            .regex(/^01[01]\d{8}$/, {
                message: "올바른 휴대폰 번호를 입력해주세요",
            }),
        verificationCode: z.string(),
        name: z.string().min(1, { message: "이름을 입력해주세요" }),
        // nickname: z
        // .string()
        // .min(1, { message: "한글자 이상 입력해주세요." }),
        gender: z.string().optional().default(""),
        birthDate: z
            .string()
            .optional()
            .default("")
            .refine(
                (val) =>
                    val === "" ||
                    /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/.test(val),
                { message: "YYYY-MM-DD 형식으로 입력해주세요" }
            ),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: "비밀번호가 일치하지 않습니다",
        path: ["confirmPassword"],
    });
